(function($) {
  // Initialize
  var _newsletterForm = $('#newsletter-form');
  var animationSpeed = 400;

  // Check submit
  _newsletterForm.on('submit', function(e) {
    // Initialize
    var _emailInput = $('input[type="email"]:first', _newsletterForm);
    var _submitInput = $('input[type="submit"]:first', _newsletterForm);
    var postData = {};
    postData[_emailInput.attr('name')] = _emailInput.val();

    // Disable sending button
    _submitInput.attr('disabled', 'disabled').attr('value', '⌲');

    // Let's do some AJAX
    $.post(_newsletterForm.attr('action'), postData, function(data) {
      if (data === 'NOK') {
        // Re-activate submit and show error
        _submitInput.removeAttr('disabled').attr('value', '↩');
        _emailInput.addClass('error');
        return false;
      }

      // Display success
      _emailInput.animate({ width: 'toggle' }, animationSpeed);
      _submitInput.attr('value', '✔').addClass('success').after(
        '<span class="success-message">' +
          $('input[name="success-message"]').val() +
        '</span>'
      );
    });

    // Prevent default behavior
    e.preventDefault();
    return false;
  });

})(jQuery);
